module.exports = __webpack_public_path__ + "img/banner-1.290daec3.png";